<div [ngClass]="labelCol">{{ label | translate }}</div>
<div [ngClass]="valueCol">
  <ng-container *ngIf="hasValue">{{ value }}</ng-container>
  <ng-content></ng-content>
</div>
